<template>
<div style="overflow:auto;height:100%">
        <div ref="fadeWhenModelOpen" class="mt-4">
        <div class="pb-2 m-4 d-flex" style="border-bottom: 1px solid #242424;position:relative">
            <h6 class="m-0 text-left pl-4">{{$t("Global ingest path")}}</h6>
        </div>
            <div class="d-inline-flex w-100 ml-4 mt-2 mb-2">
                <label style="min-width:20%;text-align:end;line-height:25px;" class="text-color">{{$t('Create Catalog as Storage Path')}}</label>
                <ul class="d-inline-block float-left pl-0 mb-0" style="list-style-type:none;margin-inline-end:19%">
                    <!-- <li class="d-inline-flex flat-left w-100 ml-2">
                    <input type="checkbox" class="bg-transparent border rounded text-light bigger-checkboxes" @input="updateUploadSettings()" v-model="uploadSettings.category_structure"/>
                    <label style="position: relative;inset-inline-start:8px !important; top:5px;">Catalog Folder Structure</label>
                    </li> -->
                    <li class="d-inline-block flat-left w-100 ml-4">
                    <div class="custom-control custom-switch">
                        <input
                            v-on:click="updateUploadSettings('create_catalog_as_bin_path',$event.target.checked)"
                            type="checkbox"
                            class="custom-control-input"
                            id="customSwitch2"
                            :checked='uploadSettings.create_catalog_as_bin_path'/>
                        <label class="custom-control-label" for="customSwitch2"></label>
                    </div>
                    <div class="config-desc">
                       {{$t('On enabling, catalog path will be created similar to storage path and asset will be tagged to created catalog')}}</div>
                    </li>
                </ul>
            </div>
            <div v-if="createCatalogAsBinPath" class="d-inline-flex w-100 ml-4 mt-2 mb-2">
                <label style="min-width:20%;text-align:end;line-height:25px;" class="text-color">{{$t('Skip Bin-id')}}</label>
                <ul class="d-inline-block float-left pl-0 mb-0" style="list-style-type:none;margin-inline-end:19%">
                    <li class="d-inline-block flat-left w-100 ml-4">
                    <div class="custom-control custom-switch">
                        <input
                            v-on:click="updateUploadSettings('skip_bin_id_on_catalog_create',$event.target.checked)"
                            type="checkbox"
                            class="custom-control-input"
                            id="customSwitch3"
                            :checked='uploadSettings.skip_bin_id_on_catalog_create'/>
                        <label class="custom-control-label" for="customSwitch3"></label>
                    </div>
                    <div class="config-desc">
                       {{$t('On enabling this flag, Bin-id will be skipped while creating catalog path as source path')}}</div>
                    </li>
                </ul>
            </div>
            <div v-if="!createCatalogAsBinPath" class="d-inline-flex w-100 float-left mt-2 ml-4 mb-3">
                <label style="min-width:20%;text-align:end" class="text-color">{{$t('Default Upload Catalog')}}</label>
                <div style="max-width: 74%;text-align: initial;">
                        <div style="display:inline-flex; position: relative;">
                            <span v-if="selectedCategoryName != undefined && selectedCategoryName.length" class="ml-4 mr-5" style="line-break: anywhere;">{{ selectedCategoryName }}</span>
                            <span v-else class="empty-field-text-styles ml-4 mr-2" style="width:65px;">NONE</span>
                            <browse-icon v-on:click.native="openCategoryBrowse()" style="height:26px;margin-inline-start:3px;position: absolute;inset-inline-end :0px;bottom: 1px;top: -2px;"></browse-icon>
                        </div>
                        <span v-if="selectedCategoryPath.length" class="catalog-path-styles ml-4 mr-2" style="line-break: anywhere;display: block;">
                            <span class="text-color mr-1">{{$t('Path')}}:</span>
                            {{selectedCategoryPath.replace("catalog://0",'')}}
                        </span>
                    <div class="config-desc ml-4">
                        {{$t('This “catalog“ will be chosen by default, while uploading/ingesting files from bins')}}.
                    </div>
                </div>
            </div>
            <div class="d-inline-flex w-100 float-left mt-2 ml-4 mb-2">
                <label style="min-width:20%;text-align:end" class="text-color">{{$t('Default Upload Path')}}</label>
                <div style="max-width: 74%;text-align: initial;">
                    <div style="display:inline-flex; position: relative;">
                        <span v-if="uploadSettings.upload_path != undefined && uploadSettings.upload_path.length" class="ml-4 mr-5" style="line-break: anywhere;">{{ uploadSettings.upload_path }}</span>
                        <span v-else class="empty-field-text-styles ml-4 mr-2" style="width:65px;">NONE</span>
                        <browse-icon v-on:click.native="openAddBinsBrowser()" style="height:26px;margin-inline-start:3px;position: absolute;inset-inline-end :0px;bottom: 1px;top: -2px;"></browse-icon>
                    </div>
                    <div class="config-desc ml-4">
                        {{$t('This “upload path“ will be chosen by default, while uploading/ingesting files from catalog')}}.
                    </div>
                </div>
            </div>
            <div class="d-inline-flex w-100 ml-4 mt-2 mb-2">
            <label style="min-width:20%;text-align:end;line-height:25px;" class="text-color">{{$t('Upload With')}}</label>
            <ul class="d-inline-block float-left pl-0" style="list-style-type:none;margin-inline-end:19%">
                <!-- <li class="d-inline-flex flat-left w-100 ml-2">
                <input type="checkbox" class="bg-transparent border rounded text-light bigger-checkboxes" @input="updateUploadSettings()" v-model="uploadSettings.category_structure"/>
                <label style="position: relative;inset-inline-start:8px !important; top:5px;">Catalog Folder Structure</label>
                </li> -->
                <li class="d-inline-block flat-left w-100 ml-4">
                <div class="custom-control custom-switch">
                    <input
                        v-on:click="updateUploadSettings('date_structure')"
                        type="checkbox"
                        class="custom-control-input"
                        id="customSwitch1"
                        :checked='uploadSettings.date_structure'/>
                    <label class="custom-control-label" for="customSwitch1">{{$t('Date Folder Structure')}}</label>
                </div>
                 <div class="config-desc">
                     When user upload using catalog context , then date folder structure created using base path as default upload path.
                    <div><b>{{$t('Example:')}}</b> If today's date is 01 Jan 2000, and upload default path set as share://NAS, then file’s upload path will be <b>Share://NAS/Jan-2000/01-01-2020/</b> .</div>
                    </div>
                </li>
            </ul>
            </div>
            <div class="m-4 d-flex" style="border-bottom: 1px solid #242424;position:relative">
                <h6 class="m-0 text-left pl-4">{{$t('Inherit parent metadata')}}</h6>
            </div>
            <div class="d-inline-flex w-100 ml-4 mt-2 mb-2">
                <label style="min-width:20%;text-align:end;line-height:25px;" class="text-color">{{$t('Inherit parent metadata for asset')}}</label>
                <ul class="d-inline-block float-left pl-0 mb-0" style="list-style-type:none;margin-inline-end:19%">
                    <!-- <li class="d-inline-flex flat-left w-100 ml-2">
                    <input type="checkbox" class="bg-transparent border rounded text-light bigger-checkboxes" @input="updateUploadSettings()" v-model="uploadSettings.category_structure"/>
                    <label style="position: relative;inset-inline-start:8px !important; top:5px;">Catalog Folder Structure</label>
                    </li> -->
                    <li class="d-inline-block flat-left w-100 ml-4">
                    <div class="custom-control custom-switch">
                        <input
                            v-on:click="updateUploadSettings('inherit_parent_metadata_for_asset',$event.target.checked)"
                            type="checkbox"
                            class="custom-control-input"
                            id="customSwitchAsset"
                            :checked='uploadSettings.inherit_parent_metadata_for_asset'/>
                        <label class="custom-control-label" for="customSwitchAsset"></label>
                    </div>
                    <div class="config-desc">
                       {{$t(uploadSettings.inherit_parent_metadata_for_asset_desc)}}</div>
                    </li>
                </ul>
            </div>
            <div class="d-inline-flex w-100 ml-4 mt-2 mb-2">
                <label style="min-width:20%;text-align:end;line-height:25px;" class="text-color">{{$t('Inherit parent metadata for subclip')}}</label>
                <ul class="d-inline-block float-left pl-0 mb-0" style="list-style-type:none;margin-inline-end:19%">
                    <!-- <li class="d-inline-flex flat-left w-100 ml-2">
                    <input type="checkbox" class="bg-transparent border rounded text-light bigger-checkboxes" @input="updateUploadSettings()" v-model="uploadSettings.category_structure"/>
                    <label style="position: relative;inset-inline-start:8px !important; top:5px;">Catalog Folder Structure</label>
                    </li> -->
                    <li class="d-inline-block flat-left w-100 ml-4">
                    <div class="custom-control custom-switch">
                        <input
                            v-on:click="updateUploadSettings('inherit_parent_metadata_for_subclip',$event.target.checked)"
                            type="checkbox"
                            class="custom-control-input"
                            id="customSwitchSubclip"
                            :checked='uploadSettings.inherit_parent_metadata_for_subclip'/>
                        <label class="custom-control-label" for="customSwitchSubclip"></label>
                    </div>
                    <div class="config-desc">
                       {{$t(uploadSettings.inherit_parent_metadata_for_subclip_desc)}}</div>
                    </li>
                </ul>
            </div>
            <div class="d-inline-flex w-100 ml-4 mt-2 mb-2">
                <label style="min-width:20%;text-align:end;line-height:25px;" class="text-color">{{$t('Inherit parent metadata for catalog')}}</label>
                <ul class="d-inline-block float-left pl-0 mb-0" style="list-style-type:none;margin-inline-end:19%">
                    <!-- <li class="d-inline-flex flat-left w-100 ml-2">
                    <input type="checkbox" class="bg-transparent border rounded text-light bigger-checkboxes" @input="updateUploadSettings()" v-model="uploadSettings.category_structure"/>
                    <label style="position: relative;inset-inline-start:8px !important; top:5px;">Catalog Folder Structure</label>
                    </li> -->
                    <li class="d-inline-block flat-left w-100 ml-4">
                    <div class="custom-control custom-switch">
                        <input
                            v-on:click="updateUploadSettings('inherit_parent_metadata_for_catalog',$event.target.checked)"
                            type="checkbox"
                            class="custom-control-input"
                            id="customSwitchCatalog"
                            :checked='uploadSettings.inherit_parent_metadata_for_catalog'/>
                        <label class="custom-control-label" for="customSwitchCatalog"></label>
                    </div>
                    <div class="config-desc">
                       {{$t(uploadSettings.inherit_parent_metadata_for_catalog_desc)}}</div>
                    </li>
                </ul>
            </div>
            <div class="m-4 d-flex" style="border-bottom: 1px solid #242424;position:relative">
                <h6 class="m-0 text-left pl-4">{{$t('Bin to Catalog Mapping')}}</h6>
            </div>
            <div class="value-style d-inline-flex bg-transparent rounded text-light input-fields searched-metadata-display-fields"
                style="margin-top:5px;margin-bottom:25px;">
                <ul class="tags-display-ul p-0 m-0" style="width:55%">
                    <li class="add-screens-styles" @click="viewEditOrCreateBinCatalogMapperDialog()">
                        <div style="margin-inline-end:10px">
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                            </svg>
                        </div>
                        <div style="font-size: 15px;line-height: 55px;">{{$t('Create Bin')}}-{{$t('Catalog Mapper')}}</div>
                    </li>
                    <li v-for="eachMap in binCatalogMappers" :key="eachMap.id" style="margin:0px !important">
                        <div class="pool-rows-styles screen-tags-name-display">
                            <div class="d-flex w-100" style="align-items:flex-start">
                                <div class="screens-name-styles">
                                    <div style="margin-top: 3px; margin-inline-end: 11px; width: 16px;height: 100%;display: inline-flex;">
                                        <svg v-if="eachMap.create_children_folder_as_catalog" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#0087A9" class="bi bi-diagram-3-fill" viewBox="0 0 16 16">
                                            <title>{{$t('Create Catalog as Storage Path')}}</title>
                                            <path fill-rule="evenodd" d="M6 3.5A1.5 1.5 0 0 1 7.5 2h1A1.5 1.5 0 0 1 10 3.5v1A1.5 1.5 0 0 1 8.5 6v1H14a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0v-1A.5.5 0 0 1 2 7h5.5V6A1.5 1.5 0 0 1 6 4.5zm-6 8A1.5 1.5 0 0 1 1.5 10h1A1.5 1.5 0 0 1 4 11.5v1A1.5 1.5 0 0 1 2.5 14h-1A1.5 1.5 0 0 1 0 12.5zm6 0A1.5 1.5 0 0 1 7.5 10h1a1.5 1.5 0 0 1 1.5 1.5v1A1.5 1.5 0 0 1 8.5 14h-1A1.5 1.5 0 0 1 6 12.5zm6 0a1.5 1.5 0 0 1 1.5-1.5h1a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5z"/>
                                        </svg>
                                    </div>
                                    <div :title="eachMap.bin_name_path.replace('share://','')" style="max-width: 68%;">
                                        {{ getFolderNameFromBinPath(eachMap.bin_name_path) }}
                                    </div>
                                    <span style="padding-inline-start: 9px;font-size: 15px;color: #9c9c9c;margin-inline-start: 6px;"> --></span>
                                </div>
                                <div v-if="eachMap.catalog_info" style="padding-inline-start:9px;min-width:50%;max-width:65%;display: inline-flex;flex-direction: row;flex-wrap: wrap;">
                                    <li v-for="(cat,indx) in eachMap.catalog_info" :key="cat._id" class='view-tags'>
                                        <span :title="getCatFullPath(cat)">{{cat.catalog_name}}</span>
                                        <span v-if="indx < (eachMap.catalog_info.length-1)">,</span>
                                    </li>
                                </div>
                            </div>
                            <div class="screen-tags-styles">
                                <div class="dropdown">
                                    <div class="nav-item nav-link dropdown-toggle" id="bd-versions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                                        <svg width="20" height="1.5em" viewBox="0 0 16 16" class="bi bi-three-dots"  fill="#C5c0c0" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/>
                                        </svg>
                                    </div>
                                    <div class="dropdown-menu dropdown-menu-md-right p-0" aria-labelledby="bd-versions">
                                        <a class="dropdown-item p-2" @click.stop.prevent="viewEditOrCreateBinCatalogMapperDialog(eachMap)">
                                            {{$t('Edit')}}</a>
                                        <a class="dropdown-item p-2" @click.stop.prevent="deleteSelectedBinCtalogMapper(eachMap)">
                                        {{$t('Delete')}}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
    </div>
    <bins-browse-modal
      ref="binsBrowseModal"
      v-if="isModalVisible"
      :workspaceList="browseWorkspaceList"
      :enableAssetMultiSelect="false"
      @close="closeModal"
      @handleFilesBrowse="selectedBinPath"
      :enableRecursive="false"
      :browseOnlyFolders="true"
      style="z-index:99"
      :parentPreSelectedPathIds="[uploadSettings.upload_path]"
    ></bins-browse-modal>
    <bins-browse-modal
      ref="catalogsBrowseModal"
      v-if="isCategoryBrowse"
      :workspaceList="catalogWorkspaceList"
      :enableAssetMultiSelect="false"
      @close="closeCatBrowse"
      @handleFilesBrowse="addSelectedCategoryId"
      :enableRecursive="false"
      :browseOnlyFolders="true"
      style="z-index:99"
      :parentPreSelectedPathIds="getUploadCatalogId()"
    ></bins-browse-modal>
    <BinCatalogPathMapperDialog v-if="viewBinCalogMapper" :selectedMapper="selectedBCMapper" @closeDialog="viewBinCalogMapper=false" @mapperUpdated="handleMpperUpdate"></BinCatalogPathMapperDialog>
</div>
</template>


<script>
import fileBrowseModel from "../files/filesBrowse.vue";
import browseIcon from "../core/InlineBrowseField.vue";
import {mapActions, mapMutations} from "vuex";
import Constants from "../../components.constants.js";
import BinCatalogPathMapperDialog from "./BinCatalogPathMapperDialog.vue";


export default {
    data(){
        return{
            isModalVisible:false,
            uploadSettings:{},
            isCategoryBrowse:false,
            selectedCategoryName:"",
            selectedCategoryPath:"",
            catalogWorkspaceList:[Constants.WORKSPACE_CATALOG],
            browseWorkspaceList:[Constants.WORKSPACE_BINS],
            createCatalogAsBinPath:false,
            binCatalogMappers:[],
            viewBinCalogMapper:false,
            selectedBCMapper:null
        }
    },
    components:{
      "browse-icon" : browseIcon,
      "bins-browse-modal": fileBrowseModel,
      BinCatalogPathMapperDialog
    },
    methods:{
        handleMpperUpdate(newMapper, mapperInfo){
            let mappersList = []
            if(newMapper){
                //validation check for bin_path
                let cIndx = this.binCatalogMappers.findIndex(item => (item.bin_path == mapperInfo.bin_path));
                if(cIndx >= 0){
                    alert("Selected Bin path is already added. Please choose different path");
                    return
                }
                if(this.binCatalogMappers){
                    mappersList = this.binCatalogMappers.map(item => ({
                                                                bin_path: item.bin_path,
                                                                catalog_path: item.catalog_path,
                                                                create_children_folder_as_catalog: item.create_children_folder_as_catalog,
                                                                uid: item.uid
                                                            }));
                }
                mappersList.unshift(mapperInfo);
            }else{
                if(this.binCatalogMappers){
                    let indx = this.binCatalogMappers.findIndex(op => op.uid == mapperInfo.uid)
                    mappersList = this.binCatalogMappers.filter(op => op.uid != mapperInfo.uid).map(item => ({
                                                                bin_path: item.bin_path,
                                                                catalog_path: item.catalog_path,
                                                                create_children_folder_as_catalog: item.create_children_folder_as_catalog,
                                                                uid:item.uid
                                                            }));
                    if(indx >= 0){
                        mappersList.splice(indx, 0, mapperInfo);
                    }else{
                        mappersList.unshift(mapperInfo);
                    }
                }
            }
            this.updateUploadSettings('bin_path_to_catalog_mapping', mappersList);
            this.viewBinCalogMapper = false;
        },
        viewEditOrCreateBinCatalogMapperDialog(mapper){
            this.viewBinCalogMapper = true;
            this.selectedBCMapper = mapper
        },
        getCatFullPath(catInfo){
            if(catInfo.parent_path){
                return (catInfo.parent_path.value + '/'+catInfo.catalog_name).replace('catalog://0','')
            }
            return catInfo.catalog_name
        },
        getFolderNameFromBinPath(path){
            const segments = path.split('/');
            return segments.pop();
        },
        getUploadCatalogId(){
            let pathList = []
            if('catalog_info' in this.uploadSettings && this.uploadSettings.catalog_info && this.uploadSettings.catalog_info.length > 0){
                pathList.push(this.uploadSettings.catalog_info[0]._id)
            }
            return pathList
        },
        openAddBinsBrowser(){
          this.isModalVisible = true;
          this.$refs.fadeWhenModelOpen.style.opacity = 0.2;
        },
        closeModal() {
              this.isModalVisible = false;
              this.$refs.fadeWhenModelOpen.style.opacity = 1;
        },
        selectedBinPath(folderInfoList){
          if(folderInfoList && folderInfoList.length > 0){
            this.uploadSettings.upload_path = folderInfoList[0].path;
            this.updateUploadSettings("upload_path")
            this.closeModal();
          }else{
            console.log("Failed to update the browsed folder path:",folderInfoList)
          }
        },
        openCategoryBrowse(){
            this.isCategoryBrowse = true;
            this.$refs.fadeWhenModelOpen.style.opacity = 0.2;
        },
        closeCatBrowse(){
            this.isCategoryBrowse = false;
            this.$refs.fadeWhenModelOpen.style.opacity = 1;
        },
        addSelectedCategoryId(browsedCatalogs){
          if(browsedCatalogs && browsedCatalogs.length > 0){
            let selectedPath = browsedCatalogs[0]
            let catId = selectedPath.parent_id_path[0]+ "/" + selectedPath._id;
            this.uploadSettings.upload_category = catId;
            this.uploadSettings.catalog_info = [selectedPath]
            this.selectedCategoryPath = selectedPath.parent_path[0].value;
            this.selectedCategoryName = selectedPath.catalog_name;
            this.updateUploadSettings("upload_category")
            this.closeCatBrowse();
          }else{
            console.log("Failed to update the browsed catalog path:",browsedCatalogs)
          }
        },
        deleteSelectedBinCtalogMapper(mapper){
            if (confirm(`Are you sure you want to delete the selected Bin-Catalog Mapper?`)) {
                let filteredMapper = this.binCatalogMappers.filter(op=>op.uid != mapper.uid)
                this.updateUploadSettings('bin_path_to_catalog_mapping', filteredMapper)
            }
        },
        updateUploadSettings(key,val = null){
            let payload={};
            payload["_id"] = this.uploadSettings["_id"]
            if(key == "date_structure"){
                this.uploadSettings.date_structure = !this.uploadSettings.date_structure;
                payload[key] = this.uploadSettings.date_structure;
            }
            if(val != null){
                payload[key] = val;
            }else{
                payload[key] = this.uploadSettings[key];
            }
            setTimeout(() => {
            this.updateUploadSettingsKeys(payload).then((data) => {
                if (data.message.includes("Failed")) {
                    this.$toast.error(data.message);
                } else {
                    this.$toast.success(data.message);
                }
            });
            }, 200);
        },
        getCategoryPath(cat_id){
            let catList = cat_id.split("/")
            let payload = {params:{assetId: catList[catList.length - 1]}}
            this.getAssetInfoFromServer(payload).then((data)=>{
                    let cat_id = data["assets"];
                    this.selectedCategoryName = cat_id.catalog_name
                    this.selectedCategoryPath = cat_id.parent_path[0].value
            })
        },

        updateUploadFields(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
            let notificationMessage = notification.message

            // this.selectedCategoryName = this.getCategoryPath(notificationMessage.upload_category);
            this.uploadSettings.date_structure = notificationMessage.date_structure;
            this.uploadSettings.upload_path = notificationMessage.upload_path;
            this.uploadSettings.create_catalog_as_bin_path = notificationMessage.create_catalog_as_bin_path;
            this.createCatalogAsBinPath = notificationMessage.create_catalog_as_bin_path;
            this.uploadSettings.skip_bin_id_on_catalog_create = notificationMessage.skip_bin_id_on_catalog_create;

            if('bin_path_to_catalog_mapping' in notificationMessage){
                this.binCatalogMappers = notificationMessage.bin_path_to_catalog_mapping;
                this.uploadSettings['bin_path_to_catalog_mapping'] = notificationMessage.bin_path_to_catalog_mapping;
            }
        },
        ...mapActions("settings", ["getUploadSettingsDetailsFromServer","updateUploadSettingsKeys"]),
        ...mapMutations("registry",["loadExternalPluginForSystemSettingsMenu"]),
        ...mapActions("assets",["getAssetInfoFromServer"]),
        ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
    },
    created(){
        this.getUploadSettingsDetailsFromServer().then((data)=>{
            if(data.upload_settings.length){
                this.uploadSettings = data.upload_settings[0];//given this only for retrieve settings, handle it when tabs comes
                let catalogInfo = this.uploadSettings.catalog_info[0];
                this.selectedCategoryName = catalogInfo.catalog_name;
                this.selectedCategoryPath = catalogInfo.parent_path["value"]
                if(Object.keys(this.uploadSettings).includes('create_catalog_as_bin_path')){
                    this.createCatalogAsBinPath = this.uploadSettings.create_catalog_as_bin_path;
                }
                if('bin_path_to_catalog_mapping' in this.uploadSettings){
                    this.binCatalogMappers = this.uploadSettings['bin_path_to_catalog_mapping']
                }
            }
        }),
        
        this.addWSEventListener({eventname:Constants.uploadSettingsNotification, callback:this.updateUploadFields,parent:"uploadSettings"});
    },
    beforeDestroy(){
        this.removeWSEventListener({eventname:Constants.uploadSettingsNotification, callback:this.updateUploadFields,parent:"uploadSettings"});        
    }
    
}
</script>

<style lang="scss" scoped>
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $danger-color: #dc3545 !important;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #5a5a5a;
    $secondary-border-color: 1px solid #2b2b2b;
    $active-green-color:#28a745;
    $svg-color:#666;
    $learn-about-text-color-hover:#b7b327;
    $active-green-icon-color: #00ff3a;
    $learn-about-text-color:#9a9620;
    $add-button-border-color:#b7b228;
    $add-button-border-on-hover:#dcd426;
    $add-button-backgroud:#1e1e1e;
    $add-button-text-color:#0b7099;
    $add-button-text-color-hover:#0193cc;


input[type='checkbox']:after{
    line-height: 1.5em;
    content: '';
    display: inline-block;
    width: 22px;
    height: 21px;
    margin-top: 5px;
    margin-inline-start: -1px;
    border: $border-color;
    border-radius: 0.25em;
    background: $primary-background;
}

input[type='checkbox']:checked:after{
    content: '✔';
    color: $active-blue !important;
    // position: absolute;
    font-size: 16px;
    line-height: 1;
    transition: all .2s;
    font-family: Helvetica, Arial, sans-serif;
    padding-inline-start: 4px;
    padding-top:2px;
}

.text-color{
  color:$dull-text-color;
  line-height:20px;
}

.bigger-checkboxes{
    height: 30px;
    width: 20px;
}
li{
    margin:0px 9px 9px 9px;
}
.border {
    border: $border-color !important;
}
.config-desc{
  color: $dull-text-color;
}
.field-description {
  font-size: 11px;
  color: $dull-text-color;
}
.comm-input-field-style{
    background: $primary-background!important;
    width: 35% !important;
    float: inline-start;
    padding: $input-field-padding;
    border: $border-color!important;
    font-size:$input-field-and-label-font-size;
    height: $input-field-height;
}
.custom-control-label{
    line-height:25px;
}

.non-editable-field{
    border: none !important;
    pointer-events: none;
    cursor: default;
    position: relative;
    bottom: 4px;
}

.config-desc,.custom-control{
  width: 100%;
  text-align: initial;
}

.empty-field-text-styles{
  color:$none-text-color;
}
.custom-switch .custom-control-label::before{
    background: transparent;
}
.custom-control-input:checked~.custom-control-label:before {
    color: #fff;
    border-color: #007bff;
    background-color: #007bff !important;
}

/* width */
::-webkit-scrollbar {
    width: 8px;
  }
  
  /* Track */
  ::-webkit-scrollbar-track {
    background: $scrollbar-track-background;
  }
  
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: $scrollbar-thumb-background;
  }
  
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: $scrollbar-thumb-on-hover-background;
  }

    .searched-metadata-display-fields{
        height: 100%;
        width: 100%;
        position: relative;
        inset-inline-start:4%;
    }

    .tags-display-ul{
        list-style-type: none;
    }
    .add-screens-styles{
        display: inline-flex;
        height: 57px;
        border: 1px solid $add-button-border-color;
        border-radius: 10px;
        width: 100%;
        justify-content: center;
        line-height: 52px;
        margin: 8px 8px;
        color:$add-button-text-color;
    }

    .add-screens-styles:hover{
        border: 1px solid $add-button-border-on-hover;
        color:$add-button-text-color-hover;
    }

.pool-rows-styles{
    display: inline-flex;
    border: 1px solid $border-color-only;
    border-radius: 10px;
    width: 55%;
    margin: 8px 8px;
    position: relative;
}
.screen-tags-name-display{
    display: inline-flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
    padding: 8px;
    padding-inline-start: 0px;
    min-height:50px;
}
.screens-name-styles{
    padding-top: 1px;
    margin-inline-start: 9px;
    max-width: 50%;
    text-align: start;
    overflow-wrap: anywhere;
    display:flex;
}
.dull-the-text{
      color:$secondary-text-color;
    }
    .view-tags {
  font-size:10px!important;
  display: inline-flex!important;
  margin: 2px!important;
  // border: 1px solid $tags-border-color!important;
  border-radius: 10px!important;
  min-width: 50px!important;
  padding: 0!important;
  text-align: center;
  width: auto!important;
  justify-content: center;
  align-items: center;
  span {
    padding: 0px 4px !important;
    margin-inline-start: 0px !important;
    font-size:14px !important;
    border-radius: 15px !important;
    color: #fff;
  }
}


.view-tags .show-main-tag-delete, .more-actions-btn {
  visibility: hidden;
}

.view-tags:hover{
  .show-main-tag-delete, .more-actions-btn {
    visibility: visible;
  }
} 


.screen-tags-styles{
    position: absolute;
    inset-inline-end: 0px;
}

.screen-tags-styles{
  display:inline-flex;
  .view-sub-tags{
    font-size: 12px!important;
    height: 30px;
    display: inline-flex!important;
    margin: 5px!important;
    border: $border-color!important;
    border-radius: 15px!important;
    min-width: 50px!important;
    padding: 0!important;
    text-align: start;
    width: auto!important;
    padding-inline-start: 12px!important;
    justify-content: start;
    padding-top: 2px!important;
    span {
      margin-inline-start: 0!important;
      font-size: 12px!important;
      border-radius: 15px!important;
      position: relative!important;
      top: 3px!important;
      width: 90%;
    }
    .show-tags-delete{
      margin: 3px!important;
      float: inline-end;
      text-align: end;
      width: 25px;
      height: 25px;
      color: $text-color;
      position: relative;
      bottom: 4px;
    }
  }
}
.dropdown-toggle{
    svg{
        justify-content: end;
    }
}
</style>